module.exports = __webpack_public_path__ + "img/KSC03254.c2d79efa.jpg";